import httpStore, { getSelectedStoreURL } from "@/api/httpStore.js";
import camelize from "camelize";
import { createQueryString } from "@/api/store/OrdersService.js";

export function updateAllParts(type) {
  return httpStore.get(`/infoauto/update_all_parts/${type}`).then(res => {
    return res.data;
  });
}
/**
 *
 * @param String procedure ex: 'update_all_products', 'update_product_940-0026'
 * @returns
 */
export function infoautoLastResult(procedure) {
  return httpStore
    .get(`/infoauto/last_call_update_result/${procedure}`)
    .then(res => {
      return res.data;
    });
}
export function cancelInfoautoProcess(procedure) {
  return httpStore
    .post(`/infoauto/cancel_process/${procedure}`)
    .then(res => res.data);
}
export function infoautoSearchCustomer(
  search,
  departamentoId = null,
  page = 1,
  limit = 100,
  orderColumn = "name",
  orderDirection = "asc"
) {
  const encodedSearch = encodeURIComponent(search);
  return httpStore
    .get(
      `/infoauto/find_customer?search=${encodedSearch}&page=${page}&limit=${limit}&orderColumn=${orderColumn}&orderDirection=${orderDirection}&departamentoId=${departamentoId}`
    )
    .then(res => {
      return res.data;
    });
}
export function infoautoCreateCustomer(newCustomer) {
  return httpStore.post(`/infoauto/customer`, newCustomer).then(res => {
    return res.data;
  });
}

export function infoautoUpdateCustomer(customerId, updatedCustomer) {
  console.log("customerId", customerId, updatedCustomer);
  return httpStore
    .put(`/infoauto/customer/${customerId}`, updatedCustomer)
    .then(res => {
      return res.data;
    });
}

// sync single product between infoauto and system
export function infoautoUpdateSinglePart(sku) {
  return httpStore.get(`/infoauto/update_single_product/${sku}`).then(res => {
    return res.data;
  });
}

export function infoautoGetSingleCustomer(infoautoPersonaId) {
  return httpStore
    .get(`/infoauto/get_single_customer/${infoautoPersonaId}`)
    .then(res => {
      return camelize(res.data);
    });
}

export function infoautoGetDocumentsCustomer(infoautoPersonaId) {
  return httpStore
    .get(`/infoauto/get_documents_customer/${infoautoPersonaId}`)
    .then(res => {
      return camelize(res.data);
    });
}

export function getInfoautoOrders(filters) {
  const newFilters = createQueryString(filters);
  return httpStore.get(`/infoauto/orders?${newFilters}`).then(res => {
    return res.data;
  });
}

export function exportAllOrdersInfoauto() {
  return httpStore.get(`/infoauto/export_all_orders`).then(res => {
    return res.data;
  });
}

export function exportSingleOrderInfoauto(orderNumber) {
  return httpStore
    .get(`/infoauto/export_single_order/${orderNumber}`)
    .then(res => {
      return res.data;
    });
}

export function getOrdersQtyByInfoautoStatus() {
  return httpStore.get(`/infoauto/orders_qty_by_status`).then(res => {
    return res.data;
  });
}

export function getModalidadVenta() {
  return httpStore.get(`/infoauto/modalidad_venta`).then(res => {
    return res.data;
  });
}

export function getPriceLevels() {
  return httpStore.get(`/infoauto/price_levels`).then(res => {
    return res.data;
  });
}

export function addPhoneToCustomer(
  infoautoPersonaId,
  phoneNumber,
  phoneType,
  areaCode = ""
) {
  return httpStore
    .post(`/infoauto/add_phone_to_customer/${infoautoPersonaId}`, {
      phone: phoneNumber,
      phoneType,
      areaCode
    })
    .then(res => {
      return res.data;
    });
}

export function addAddressToCustomer(infoautoPersonaId, address) {
  return httpStore
    .post(`/infoauto/add_address_to_customer/${infoautoPersonaId}`, address)
    .then(res => {
      return res.data;
    });
}

export function updateAddressToCustomer(infoautoPersonaId, address) {
  return httpStore
    .put(`/infoauto/update_address_to_customer/${infoautoPersonaId}`, address)
    .then(res => {
      return res.data;
    });
}

export function updatePhoneToCustomer(infoautoPersonaId, phone) {
  return httpStore
    .put(`/infoauto/update_phone_to_customer/${infoautoPersonaId}`, phone)
    .then(res => {
      return res.data;
    });
}

// Address hierarchy endpoints for Costa Rica
export function getAddressPaises() {
  return httpStore.get(`/infoauto_address/paises`).then(res => {
    return res.data;
  });
}

// Países de infoauto_paises como opciones { code, label } para los selects.
// Cada tienda tiene su propia tabla, así que se cachea por URL de tienda.
// Los cod_pais vienen mixtos (ISO-2, ISO-3 o numéricos de Infoauto); los que
// no tienen código no se pueden elegir, y si dos países comparten código
// (Infoauto repite alguno) queda el primero porque son el mismo valor.
const countriesCache = {};

export function getInfoautoCountries() {
  const storeUrl = getSelectedStoreURL() || "";
  if (!countriesCache[storeUrl]) {
    countriesCache[storeUrl] = getAddressPaises()
      .then(paises => {
        const seen = new Set();
        return (Array.isArray(paises) ? paises : []).reduce((list, pais) => {
          const code = (pais.codPais || "").trim();
          if (!code || code === "." || seen.has(code)) {
            return list;
          }
          seen.add(code);
          list.push({ code, label: (pais.nombrePais || "").trim() || code });
          return list;
        }, []);
      })
      .catch(error => {
        delete countriesCache[storeUrl];
        throw error;
      });
  }
  return countriesCache[storeUrl];
}

export function getAddressProvincias(nombrePais) {
  const encodedPais = encodeURIComponent(nombrePais);
  return httpStore
    .get(`/infoauto_address/provincias?nombre_pais=${encodedPais}`)
    .then(res => {
      return res.data;
    });
}

export function getAddressCantones(codProvincia, codPais, nombrePais) {
  const params = new URLSearchParams();
  params.append("cod_provincia", codProvincia);
  if (codPais) {
    params.append("cod_pais", codPais);
  } else if (nombrePais) {
    params.append("nombre_pais", nombrePais);
  }
  return httpStore
    .get(`/infoauto_address/cantones?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}

export function getAddressDistritos(
  cod_provincia,
  cod_canton,
  cod_pais,
  nombre_pais
) {
  const params = new URLSearchParams();
  params.append("cod_provincia", cod_provincia);
  params.append("cod_canton", cod_canton);
  if (cod_pais) {
    params.append("cod_pais", cod_pais);
  } else if (nombre_pais) {
    params.append("nombre_pais", nombre_pais);
  }
  return httpStore
    .get(`/infoauto_address/distritos?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}

export function getAddressBarrios(
  cod_provincia,
  cod_canton,
  cod_distrito,
  cod_pais,
  nombre_pais
) {
  const params = new URLSearchParams();
  params.append("cod_provincia", cod_provincia);
  params.append("cod_canton", cod_canton);
  params.append("cod_distrito", cod_distrito);
  if (cod_pais) {
    params.append("cod_pais", cod_pais);
  } else if (nombre_pais) {
    params.append("nombre_pais", nombre_pais);
  }
  return httpStore
    .get(`/infoauto_address/barrios?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}

// Estados/ciudades cacheados de Infoauto (VE/USA); cod_pais en ISO-2
export function getAddressEstados(codPais) {
  const params = new URLSearchParams({ cod_pais: codPais });
  return httpStore
    .get(`/infoauto_address/estados?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}

export function getAddressCiudades(codPais, codEstado) {
  const params = new URLSearchParams({
    cod_pais: codPais,
    cod_estado: codEstado
  });
  return httpStore
    .get(`/infoauto_address/ciudades?${params.toString()}`)
    .then(res => {
      return res.data;
    });
}
